<template>
  <div class="embed-container">
    <iframe id="lab-iframe" :src="labUrl" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  props: {
    labUrl: String,
  },
  mounted() {
    this.openLab()
  },
  methods: {
    openLab() {
      console.log('opening LAB!!!', this.labUrl)
      this.$emit('finishLoading')
    },
  },
  watch: {
    '$route.params': function () {
      console.log(this.labUrl)
      this.$emit('finishLoading')
    },
  },
}
</script>

<style lang="scss" scoped>
.embed-container {
  margin: 0 -15px;
  #lab-iframe {
    width: 100%;
    height: calc(100vh - 64px - 64px - 80px);
    border: none;
    overflow: hidden;
  }
}
</style>
